import React, { useState } from "react";
import { deleteData, postData } from "../../Service/ApiMethod";
import { JOBSEEKER_CHATS, Reset_counter } from "../../Service/service";
import { useTranslation } from "react-i18next";
import moment from "moment";
const MessageBox = (props) => {
  // const setDataa = props?.setDataa
  const dataa = props?.dataa

  const { t } = useTranslation()

  const [reset, setReset] = useState()
  const [popUp, setPopUp] = useState(false)

  const MessageResetCounter = () => {


    const obj = {
      jobseeker_id: idd
    }
    postData(obj, Reset_counter)
      .then((res) => res.json())
      .then((res) => {
        console.log(res, "resetcounter");
        setReset(res?.data);
      })
  };






  // const date = moment(props?.jobSeekerDetails?.updated_at);



  const id = props?.jobSeekerDetails?.id
  const idd = props?.jobSeekerDetails?.jobseeker_id

  console.log('id', id)



  function dateToFromNowDaily(myDate) {

    var fromNow = moment(myDate).format('ddd');

    return moment(myDate).calendar(null, {

      lastDay: '[Yesterday]',
      sameDay: '[Today]',

      // when the date is further away, use from-now functionality             
      sameElse: function () {
        return "[" + fromNow + "]";
      }
    });
  }

  const deleteChat = () => {

    const obj = {
      chat_id: id
    }
    deleteData(obj, JOBSEEKER_CHATS)
      .then((resp) => resp.json())
      .then((data) => {
        alert(data?.message)
        console.log('recomended msg1', data.data);
        props?.setDataa(!dataa)
        console.log('111', data)
      })
      .catch((err) => {
        console.log("Error ", err);

      });
  }

  return (
    <>
      {
        (props?.jobSeekerDetails?.length !== 0
          ?
          <>
            <div
              className="message-box active"
              id={props?.jobSeekerDetails?.jobseeker_id}
              onClick={() => {

                props?.openChatWindow();
                MessageResetCounter()


              }
              }
            >
              <div className="row flex-center message-box-row  " style={{ justifyContent: "start" }}>
                <div className="col-2 pr-0 flex-center ">
                  <img src={(props?.jobSeekerDetails?.jobseeker_image) || "./images/Vector.png"} className="msg-profile" alt="" style={{ position: 'unset', zIndex: '0', }} />
                  <span className="mt-4 pr-1 " style={{ position: 'absolute', right: '6px', top: '1px' }}>
                    {props?.jobSeekerDetails?.time_difference >= 5 ? <span className="dot"></span> : <span className="dotOn"> </span>}
                  </span>



                </div>
                <div className="col-10 ps-0">
                  <h4 className="msg-name">{props?.jobSeekerDetails?.jobseeker_name}</h4>
                  <span className="status status-day" style={{}}>

                    {t(dateToFromNowDaily(props?.jobSeekerDetails?.updated_at))}


                  </span>
                  <img className="status" style={{ height: '16px' }} src='./images/verticalDots.png'
                    onClick={(e) => {
                      e.stopPropagation()
                      setPopUp(!popUp)

                    }} />


                  {popUp &&

                    <div className="status-dlt" style={{}}>

                      <div className="" style={{ border: '1px solid black', textAlign: 'center', borderRadius: '2px', cursor: 'pointer', backgroundColor: 'grey' }} onClick={(e) => {
                        e.stopPropagation()
                        deleteChat()
                        setPopUp(!popUp)
                      }}>{t('Delete')}</div>
                    </div>

                  }
                  <div style={{ display: 'flex', alignContent: 'center' }}>
                    <span className="textmsg"> {props?.jobSeekerDetails?.last_sent == "recruiter" ? `${t('You')}` : props?.jobSeekerDetails?.jobseeker_name}</span>
                    <span className="textmsg mx-1 " style={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden'
                    }}>
                      : {props?.jobSeekerDetails?.last_message}
                    </span>
                  </div>
                </div>

                {
                  (props?.jobSeekerDetails?.unread_count !== 0) && <span
                    className="col-2  d-flex flex-end "
                    style={{ flexDirection: "column", right: '30px', position: 'absolute', zIndex: '9999999999999' }}
                  >
                    {/* <p className="text">Today</p> */}
                    <p className="no_messages"> {props?.jobSeekerDetails?.unread_count}</p>
                  </span>
                }



              </div>
            </div>
            {/* <hr className="m-0" style={{ fontWeight: '2px solid bold', fonSize: '5px', color: 'blue', background: 'blue' }} /> */}
          </>
          : <div color="red">{t('No Message Found')}</div>)}


    </>
  );
};

export default MessageBox;
